import React from "react";
import { useAuth0 } from "../../auth/react-auth0-spa";
import { useAppContext } from "../../contexts/AppContext";
import NavigationBar from "carbon-react/lib/components/navigation-bar";
import { Menu, MenuItem, SubmenuBlock } from "carbon-react/lib/components/menu";
import logo from "../../assets/sage_logo.svg";
import { getAgentRoleDisplayValue } from "../../constants/model";
import { useLocalization } from "../../contexts/localization/Localization";

const MainNavigation = () => {
  const { isAuthenticated, logout, user } = useAuth0();
  const { agentInfo } = useAppContext();
  const { currentLocale, supportedLocales, setLocale } = useLocalization();

  const agentMenuItem = () => {
    if (!isAuthenticated || !user) return;
    let agentDisplayName = user.name;

    if (agentInfo) {
      const formattedAgentRole = getAgentRoleDisplayValue(agentInfo.role);
      agentDisplayName = `${agentDisplayName} (${formattedAgentRole})`;
    }

    return (
      <div id="nav-agent-info">
        <MenuItem submenu={agentDisplayName} submenuDirection="right">
          <SubmenuBlock>
            <MenuItem
              onClick={(event) => {
                logout();
                event.preventDefault();
              }}
            >
              <span id="nav-logout-link">Logout</span>
            </MenuItem>
          </SubmenuBlock>
        </MenuItem>
      </div>
    );
  };

  const localeMenuItem = () => {
    const localeName =
      currentLocale && currentLocale.length > 0 ? currentLocale : "N/a";

    return (
      <MenuItem submenu={localeName} submenuDirection="right">
        <SubmenuBlock>
          {supportedLocales?.map((locale) => {
            return (
              <MenuItem
                onClick={(event) => {
                  setLocale(locale);
                  event.preventDefault();
                }}
              >
                {locale}
              </MenuItem>
            );
          })}
        </SubmenuBlock>
      </MenuItem>
    );
  };

  return (
    <NavigationBar as="secondary">
      <img id="logo" src={logo} alt="Sage" draggable="false" />
      <div id="systemName">Admin Tool</div>
      <div className="align-right nav-top-margin">
        <Menu as="secondary">
          {/* {localeMenuItem()} */}
          {agentMenuItem()}
        </Menu>
      </div>
    </NavigationBar>
  );
};

export default MainNavigation;
